<div class="table-header" [ngClass]="cssClass">
  <div class="table-header__info">
    <span #headerSpan [pTooltip]="tooltip">{{ header }} </span>
    <i *ngIf="description" [pTooltip]="description" class="pi pi-question-circle table-header-tooltip pl-1"> </i>
  </div>
  <ng-container *ngIf="sortable">
    <ng-container [ngSwitch]="sortDirection">
      <i *ngSwitchCase="undefined" class="pi pi-sort-alt" (click)="sort(SortDirection.ASC)"></i>
      <i *ngSwitchCase="SortDirection.NONE" class="pi pi-sort-alt" (click)="sort(SortDirection.ASC)"></i>
      <i *ngSwitchCase="SortDirection.ASC" class="pi pi-sort-amount-up" (click)="sort(SortDirection.DESC)"></i>
      <i *ngSwitchCase="SortDirection.DESC" class="pi pi-sort-amount-down" (click)="sort(SortDirection.NONE)"></i>
    </ng-container>
  </ng-container>
</div>
